import React from 'react'
import { Col, Descriptions, Image, Row } from 'antd'
import { ImageFallback } from 'helpers/constanst'
import { numberWithComma } from 'helpers/format'
import styled from 'styled-components'
import { appConfig } from 'config'
import { StockListData } from 'Store/stock/types'

type Props = {
  stockData?: StockListData
}

const ProductInfo: React.FunctionComponent<Props> = props => {
  const { stockData } = props

  const renderImage = (photo: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + photo} fallback={ImageFallback} />
  )

  return (
    <Row justify="center" gutter={[8, 8]} align="middle">
      <Col md={2} xs={6}>
        {renderImage(stockData?.product_option_photo)}
      </Col>
      <Col md={18} xs={18}>
        <Descriptions bordered size="small">
          <Descriptions.Item label="ชื่อสินค้า" span={2}>
            {stockData?.product_title} ({stockData?.product_option_title})
          </Descriptions.Item>
          <Descriptions.Item label="รหัสสินค้า" span={2}>
            {stockData?.product_code}
          </Descriptions.Item>
          <Descriptions.Item label="หน่วย" span={2}>
            {stockData?.uom || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="จำนวนคงเหลือปัจจุบัน" span={2}>
            {numberWithComma(stockData?.quantity_all || 0)} {stockData?.uom}
          </Descriptions.Item>
        </Descriptions>
      </Col>
    </Row>
  )
}

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 100%;
  object-fit: cover;
  max-width: 100px;
`

export default ProductInfo
